import { homeRoutes, asyncRoutesDMS, asyncRoutesDSP, asyncRoutesERP, asyncRoutesLY, asyncRoutesAI, asyncRoutesFN, constantRoutes, adminRoutes } from '@/router'
import global from '@/global' // global config

/**
 * 通过meta.permissionMap判断是否与当前用户权限匹配
 * @param router
 * @param permissionMap
 */
function hasPermission(router, permissionMap) {
  let hasPermission = false
  if (router.meta && router.meta.permission_uri) {
    const uri = router.meta.permission_uri
    let index
    for (index in permissionMap) {
      if (!permissionMap.hasOwnProperty(index)) continue
      if (permissionMap[index].uri === uri) {
        hasPermission = index
        break
      }
    }
  }
  return hasPermission
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap asyncRouterMap
 * @param resMap
 */
function filterAsyncRoutes(asyncRouterMap, resMap) {
  return asyncRouterMap.filter(route => {
    if (!route.hasOwnProperty('meta') || !route.meta.hasOwnProperty('permission_uri')) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRoutes(route.children, resMap)
      }
      return true
    }
    const mapIndex = hasPermission(route, resMap)
    if (mapIndex !== false) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRoutes(route.children, resMap[mapIndex].children)
      }
      return true
    } else {
      return false
    }
  })
}

const state = {
  routes: [],
  addRouters: [],
  permissionUri: [],
  permissionAll: [],
  routesType: 'DMS',
  permissionModule: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_PERMISSION_MODULE: (state, module) => {
    state.permissionModule = module
  },
  SET_URI: (state, permissionUri) => {
    state.permissionUri = permissionUri
  },
  SET_PERMISSION_ALL: (state, permissionAll) => {
    state.permissionAll = permissionAll
  },
  SET_ROUTESTYPE: (state, type) => {
    state.routesType = type
  }
}

const actions = {
  changeRouterType({ commit }, type) {
    commit('SET_ROUTESTYPE', type)
  },
  generateRoutes({ commit }, data) {
    return new Promise(resolve => {
      asyncRoutesDSP.forEach(element => {
        element.type = 'DSP'
      })
      asyncRoutesERP.forEach(element => {
        element.type = 'ERP'
      })
      asyncRoutesDMS.forEach(element => {
        element.type = 'DMS'
      })
      asyncRoutesLY.forEach(element => {
        element.type = 'LY'
      })
      asyncRoutesAI.forEach(element => {
        element.type = 'AI'
      })
      asyncRoutesFN.forEach(element => {
        element.type = 'FA'
      })
      // // 付费预估只能管理员看，暂时
      // if (data.user_info.super_manager === 1) {
      //   asyncRoutesDMS.forEach(element => {
      //     if (element.name === 'Market') {
      //       if (element.children.length > 0) {
      //         element.children.forEach(item => {
      //           if (item.name === 'PaymentEstimate') {
      //             item.meta.permission_uri = '/dms/market/pay-estimate'
      //           }
      //         })
      //       }
      //     }
      //   })
      // }

      const permission = []
      const permission_uri = []
      data.module.forEach(item => {
        permission.push(...data[item].permission)
        permission_uri.push(...data[item].permission_uri)
      })
      let accessRoutes = filterAsyncRoutes([...asyncRoutesDMS, ...asyncRoutesDSP, ...asyncRoutesERP, ...asyncRoutesLY, ...asyncRoutesAI, ...asyncRoutesFN], permission)
      if (accessRoutes.length !== 0) {
        const index = accessRoutes.findIndex(_ => {
          return _.children.length > 0
        })
        homeRoutes[0].redirect = accessRoutes[index].path + '/' + accessRoutes[index].children[0].path
      }
      accessRoutes = accessRoutes.concat(homeRoutes)

      if (data.user_info.super_manager === 1) {
        // *代表两种后台都有 超管
        adminRoutes.forEach(element => {
          element.type = '*'
        })
        accessRoutes = accessRoutes.concat(adminRoutes)
      }
      accessRoutes.push({ path: '*', redirect: '/', hidden: true })
      commit('SET_ROUTES', accessRoutes)
      commit('SET_URI', permission_uri)
      commit('SET_PERMISSION_MODULE', data.module)
      commit('SET_PERMISSION_ALL', data.permission_all)
      if (data.module.length === 1) {
        const module = global.modules.find(modules => modules.value.toUpperCase() === data.module[0].toUpperCase() && modules.href)
        if (module) {
          location.href = module.href
        }
      }
      resolve(accessRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
